<slick-emailer-dialog *ngIf='emailerModel' #emailerDialogRef [(ngModel)]='emailerModel'
		[toEmailAddressList]='toEmailAddresses' 
		(toAddressSearch)='toAddressSearch($event)'
		(sendEmailClick)='onSendEmail($event)'
		(cancelEmailClick)='onCancelEmail()'>
</slick-emailer-dialog>

<slick-confirm-dialog #noEmailAddressEnteredRef showCancelButton='false'>
	<h5 class="border-0 p-0 m-0">No email addresses entered. Please enter at least 1 email address.</h5>
</slick-confirm-dialog>